import {Component, Inject, OnInit} from '@angular/core';
import {ListaCompra} from "../../../../../_models/lista-compra";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
  selector: 'app-historico-compra',
  templateUrl: './historico-compra.component.html',
  styleUrls: ['./historico-compra.component.scss']
})
export class HistoricoCompraComponent implements OnInit {
  displayedColumns = ['comercio_identificador', 'codigo', 'descripcion', 'cantidad', 'monto'];
  dataSource: Array<ListaCompra | any> = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.dataSource = data.carrito;
  }

  ngOnInit(): void {
  }
  /** Gets the total cost of all transactions. */
  getTotalCost() {
    return this.dataSource.map(t => t.monto).reduce((acc, value) => acc + value, 0);
  }

  getCantidad() {
    let sum = 0;
    this.dataSource.forEach( e => {
      sum += e.cantidad;
    });
    return sum;
  }
}
